/* eslint-disable react/prop-types */
import { Grid, TextField } from "@mui/material";
import MDTypography from "components/MDTypography";

function TextRow({
  title,
  code,
  value,
  error,
  touched,
  handleChange,
  handleBlur,
  isRequired,
  type,
}) {
  const isRequiredNormalized = isRequired ?? null;
  return (
    <Grid item xs={12} sm={6}>
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        {title}
        {isRequiredNormalized ? <span style={{ color: "red" }}>*</span> : null}
      </MDTypography>
      <TextField
        variant="outlined"
        fullWidth
        id={code}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        error={error && touched}
        helperText={error}
        type={type ?? "text"}
      />
    </Grid>
  );
}

export default TextRow;
